package es.subastia.data.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import es.subastia.data.mapper.toData
import es.subastia.data.mapper.toDomain
import es.subastia.data.model.SavedSearchDataModel
import es.subastia.domain.model.SavedSearchModel
import es.subastia.domain.repository.SavedSearchRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class SavedSearchRepositoryImpl : SavedSearchRepository {

    private val firestore = Firebase.firestore

    override suspend fun saveSearch(savedSearch: SavedSearchModel) {
        val collection = firestore.collection("users").document(savedSearch.userId).collection("saved_searches")
        
        val docRef = if (savedSearch.id.isBlank()) {
            collection.document
        } else {
            collection.document(savedSearch.id)
        }
        
        // Ensure the ID is part of the saved data
        val dataToSave = savedSearch.copy(id = docRef.id).toData()
        docRef.set(dataToSave)
    }

    override fun getSavedSearches(userId: String): Flow<List<SavedSearchModel>> {
        return firestore.collection("users").document(userId).collection("saved_searches")
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { doc ->
                    // Deserialize and ensure ID matches document ID (good practice)
                    doc.data<SavedSearchDataModel>().copy(id = doc.id).toDomain()
                }
            }
    }

    override suspend fun deleteSearch(searchId: String, userId: String) {
        firestore.collection("users").document(userId).collection("saved_searches").document(searchId).delete()
    }
}
